"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_designer_constants_1 = require("../../components/designer/form/form-designer.constants");
var controller_model_1 = require("../../layout-models/form-models/controller.model");
var layout_utils_1 = require("../layout-utils");
var FormSubwayMapElement = /** @class */ (function () {
    function FormSubwayMapElement(domInfo) {
        this.domInfo = domInfo;
    }
    FormSubwayMapElement.prototype.onClone = function (designerContext) {
        if (!this.newSubwayMap()) {
            var draggingElement_1 = this.domInfo.getElem();
            var cloned_1 = false;
            var animationIndex_1 = 0;
            var offsetTop_1 = 0;
            var offsetLeft_1 = 0;
            var getCoordinates_1 = function (mouseEvent) {
                offsetLeft_1 = mouseEvent.clientX - draggingElement_1.offsetLeft;
                offsetTop_1 = mouseEvent.clientY - draggingElement_1.offsetTop;
            };
            var animate_1 = function () {
                animationIndex_1 += 1;
            };
            draggingElement_1.onmousemove = function (mouseEvent) {
                if (designerContext.itemInTrash) {
                    draggingElement_1.classList.add('form-designer__subway--trash');
                }
                else {
                    draggingElement_1.classList.remove('form-designer__subway--trash');
                }
                if (!cloned_1) {
                    getCoordinates_1(mouseEvent);
                    cloned_1 = true;
                }
                if (animationIndex_1 <= 20) {
                    draggingElement_1.style.width = "calc(100% - 300px - 240px - " + (animationIndex_1 * 4).toString() + "px)";
                    draggingElement_1.style.transform = "scale(" + (1 - (animationIndex_1 / 100)).toString() + ")";
                    animate_1();
                }
            };
        }
    };
    FormSubwayMapElement.prototype.onDrag = function (designerContext) {
        designerContext.subwayMapDragging = true;
        designerContext.showSubwayMapTrashBin = true;
        designerContext.itemInTrash = true;
    };
    FormSubwayMapElement.prototype.onDrop = function (designerContext) {
        if (this.newSubwayMap()) {
            designerContext.initSubwayMapControl(new controller_model_1.ControllerModel(layout_utils_1.LayoutUtils.uniqueId(), designerContext.subwayMapModels[0], true));
        }
        else if (this.subwayMapDeleted()) {
            designerContext.subwayMapModels = [];
            designerContext.layout.subwayMap = undefined;
            designerContext.isSubwayMapExists = false;
            designerContext.subwayMapList = [];
        }
    };
    FormSubwayMapElement.prototype.onHover = function (designerContext) { };
    FormSubwayMapElement.prototype.subwayMapDeleted = function () {
        return (this.domInfo.sourceIdEquals(form_designer_constants_1.FormDesignerConstants.SUBWAYMAP_CONTAINER) &&
            this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.SUBWAYMAP_TRASH_BIN));
    };
    FormSubwayMapElement.prototype.subwayMapInTrash = function () {
        return this.domInfo.containerIdEquals(form_designer_constants_1.FormDesignerConstants.SUBWAYMAP_TRASH_BIN);
    };
    FormSubwayMapElement.prototype.newSubwayMap = function () {
        return this.domInfo.elemIdEquals(form_designer_constants_1.FormDesignerConstants.NEW_SUBWAYMAPS);
    };
    return FormSubwayMapElement;
}());
exports.FormSubwayMapElement = FormSubwayMapElement;
//# sourceMappingURL=form-subwaymap.element.js.map